import {
  Button,
  Container,
  DateLabel,
  LeftArrow,
  Navigation,
  NavigationArrows,
  RightArrow,
  Select,
  ViewButtons,
} from './ToolbarStyle';
import { Tooltip, rem } from '@mantine/core';
import { memo, RefObject, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import { views } from '../../shared/views-list';

type ToolbarPropsType = {
  calendarRef: RefObject<FullCalendar>;
  isRefReady: boolean;
  view: string;
  defaultView: string;
  setView: React.Dispatch<React.SetStateAction<string>>;
  title: string;
};

export const Toolbar = memo(
  ({
    calendarRef,
    isRefReady,
    view,
    defaultView = 'timeGridWeek',
    setView,
    title,
  }: ToolbarPropsType) => {
    useEffect(() => {
      queueMicrotask(() => {
        const calApi = calendarRef.current?.getApi();
        if (defaultView && calApi) {
          calApi.changeView(defaultView);
          setView(defaultView);
        }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultView]);

    const handleDateChange = (direction: 'prev' | 'today' | 'next'): void => {
      const calApi = calendarRef.current?.getApi();
      if (calApi) {
        if (direction === 'prev') {
          calApi.prev();
        } else if (direction === 'next') {
          calApi.next();
        } else {
          calApi.today();
        }
      }
    };

    const handleViewChange = (view: string) => {
      const calApi = calendarRef.current?.getApi();
      if (calApi) {
        calApi.changeView(view);
        setView(view);
      }
    };

    return (
      <Container>
        <Navigation>
          <NavigationArrows>
            <Tooltip label="Previous" withArrow transitionProps={{ transition: 'rotate-right' }}>
              <LeftArrow
                style={{ width: rem(30), height: rem(30) }}
                onClick={() => handleDateChange('prev')}
              />
            </Tooltip>
            <Tooltip label="Next" withArrow transitionProps={{ transition: 'rotate-right' }}>
              <RightArrow
                style={{ width: rem(30), height: rem(30) }}
                onClick={() => handleDateChange('next')}
              />
            </Tooltip>
          </NavigationArrows>
          <Button onClick={() => handleDateChange('today')}>Today</Button>
        </Navigation>
        <DateLabel>{title}</DateLabel>
        <ViewButtons>
          <Select
            value={view}
            data={views}
            onChange={(option) => {
              if (option) handleViewChange(option);
            }}
            allowDeselect={false}
            checkIconPosition="right"
          />
        </ViewButtons>
      </Container>
    );
  }
);
